"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _constants = require("@studio/constants");
function subscribeToRooms() {
  return function (dispatch, getState, socket) {
    var _getState = getState(),
      _getState$broadcast = _getState.broadcast,
      broadcastId = _getState$broadcast._id,
      team = _getState$broadcast.team,
      event = _getState$broadcast.event;
    var params = {
      teamId: team,
      eventId: event,
      broadcastId: broadcastId
    };
    socket.subscribe("".concat(_constants.BROADCAST_PREFIX, ".").concat(broadcastId));
    socket.subscribe("".concat(_constants.BROADCAST_DIRECTOR_PREFIX, ".").concat(broadcastId), params);
    socket.subscribe("event.".concat(event), params);
    socket.emit(_constants.BROADCAST_JOIN_SYNC_SERVER_TIME, {
      broadcastId: broadcastId
    });
    dispatch({
      type: _constants.SUBSCRIBE_TO_ROOMS,
      payload: params
    });
  };
}
var _default = exports["default"] = subscribeToRooms;